import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, IsActiveMatchOptions, NavigationEnd } from '@angular/router';
import { AtramModalComponent } from 'src/app/shared/components/atram-modal/atram-modal.component';
import { AuthService, LocalStorageService } from '../../core.module';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {

  @ViewChild('atramModal')
  public atramModal: AtramModalComponent = new AtramModalComponent;

  public openNav: boolean = false;
  public hamburgerClick: boolean = false;

  constructor(
    public localStorageService: LocalStorageService,
    public authService: AuthService,
    public router: Router,
    public route: ActivatedRoute
  ) {
    this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          if(this.router.url !== '/faq'){
            this.localStorageService.remove('prevUrl');
            this.localStorageService.set('prevUrl',this.router.url);
          }
        }
      }
    );
    this.localStorageService.watchStorage().subscribe(
      (data: string) =>{

      }
    )
   }

  ngOnInit(): void {
  }

  onClickHamburger(){
    // this.hamburgerClick = true;
    this.openNav = !this.openNav;
  }

  isRouterLinkActive(routerLink: string): boolean {
    const matchOptions: IsActiveMatchOptions = {
      paths: 'exact',
      matrixParams: 'exact',
      queryParams: 'subset',
      fragment: 'ignored'
  };
    return this.router.isActive(routerLink, matchOptions);
  }

  navigateUrl(routerLink: string): void{
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl(routerLink,{skipLocationChange:false});
  }

  goToFAQ(){
    this.router.navigateByUrl(`/faq`, { skipLocationChange: false });
  }

  goBack(){
    let previousUrl = String(this.localStorageService.get('prevUrl') || '/');
    this.router.navigateByUrl(previousUrl, { skipLocationChange: false});
  }

  goToSignIn(){   
    this.atramModal.show();
    this.atramModal.size = 'xs';
    this.atramModal.status = 'logout';
    this.atramModal.headerText = 'Are you sure you want to logout?';
    this.atramModal.bodyText = '';
    this.atramModal.okButtonText = 'Yes';
    this.atramModal.cancelButtonText ='No';
    this.atramModal.showCancelButton = true;
    this.atramModal.showCloseButton = false;
    this.atramModal.confirmationSubject
      .subscribe((confirmation: boolean) => {
        if (confirmation) {
          this.authService.logOut();
          // OK
        } else {
          // Cancel
        }
        this.atramModal.hide();
      });
    return;
  }

}
